<template>
    <!--新增、修改资源录入项-->
    <div id="AddEditFormItem">
        <el-form class="formBox flex_1" size="small" :inline="true" :model="form" :ref="refName" label-width="150px"
                 :disabled="method==='view'">
            <div v-for="(item, index) in list.filter(v => v.basicAssemblyId != '19' && v.basicAssemblyId != '20')"
                 :key="index"
                 :class="item.basicAssemblyId == 3 || item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 16 || item.basicAssemblyId == 17 || item.basicAssemblyId == 18 || item.basicAssemblyId == 23 ? 'w100' : 'formItem'"
                 v-if="getBasicForAdd(item) && item.showRuleFlag">
                <el-form-item class="w100i" :label="item.basicRename+'：'" :prop="item.basicCode"
                              :rules="[{ required: item.basicRequired == '0' ? true: false, message: '必填项不能为空', trigger: 'change' }, validatorDataRule(item)]"
                              v-if="item.basicAssemblyId != '18'">
                    <!--单行文本-->
                    <el-input v-model.trim="form[item.basicCode]" placeholder="请输入"
                              :maxlength="item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleMax ? (item.metadataBasicDataRuleVo.ruleMax)*1 : 200"
                              clearable @input="fieldValChange(item)"
                              v-if="item.basicAssemblyId == 1"
                              :disabled="item.metadataBasicDataRuleVo && (item.metadataBasicDataRuleVo.ruleMode == '1' || item.metadataBasicDataRuleVo.ruleMode == '2')"></el-input>
                    <!--多行文本-->
                    <el-input v-model.trim="form[item.basicCode]" placeholder="请输入"
                              :maxlength="item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleMax ? (item.metadataBasicDataRuleVo.ruleMax)*1 : 2000"
                              type="textarea"
                              :rows="1" v-if="item.basicAssemblyId == 2"
                              :disabled="item.metadataBasicDataRuleVo && (item.metadataBasicDataRuleVo.ruleMode == '1' || item.metadataBasicDataRuleVo.ruleMode == '2')"></el-input>
                    <!--富文本-->
                    <Editor :ref="`editor${item.id}`" :editortext="form[item.basicCode]"
                            @changeHtml="contentGetEditor($event, item)"
                            v-if="item.basicAssemblyId == 3 && method != 'view'"></Editor>
                    <div id="Editor" v-if="item.basicAssemblyId == 3 && method == 'view'"
                         v-html="form[item.basicCode]"></div>
                    <!--下拉单选、多选-->
                    <el-select class="w100i" v-model="form[item.basicCode]"
                               :multiple="item.basicAssemblyId == 6" placeholder="请选择" clearable
                               v-if="item.basicAssemblyId == 4 || item.basicAssemblyId == 6" @change="hidingRule(item)">
                        <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                   :label="v.basicRange"
                                   :value="v.basicRange"></el-option>
                    </el-select>
                    <!--单选框组-->
                    <el-radio-group v-model="form[item.basicCode]" v-if="item.basicAssemblyId == 5"
                                    @input="hidingRule()">
                        <el-radio v-for="(v,i) in item.basicRangeList" :key="i" :label="v.basicRange">
                            {{v.basicRange}}
                        </el-radio>
                    </el-radio-group>
                    <!--多选框组-->
                    <el-checkbox-group v-model="form[item.basicCode]" v-if="item.basicAssemblyId == 7"
                                       @change="hidingRule()">
                        <el-checkbox v-for="(v,i) in item.basicRangeList" :key="i" :label="v.basicRange">
                            {{v.basicRange}}
                        </el-checkbox>
                    </el-checkbox-group>
                    <!--时间选择框-->
                    <el-time-picker class="w100i"
                                    v-model="form[item.basicCode]" value-format="yyyy-MM-dd HH:mm:ss"
                                    format="HH:mm:ss" clearable placeholder="请选择"
                                    v-if="item.basicAssemblyId == 8" @change="fieldValChange(item)"></el-time-picker>
                    <!--日期选择框-->
                    <el-date-picker class="w100i"
                                    v-model="form[item.basicCode]" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                    :type="setDatePickerType(item)"
                                    clearable placeholder="请选择"
                                    v-if="item.basicAssemblyId == 9" @change="fieldValChange(item)"></el-date-picker>
                    <!--开关-->
                    <el-switch v-model="form[item.basicCode]" active-value="开" inactive-value="关"
                               v-if="item.basicAssemblyId == 10" @change="hidingRule()"></el-switch>
                    <!--数字-->
                    <el-input v-model.trim="form[item.basicCode]" placeholder="请输入" maxlength="19" clearable
                              @input="fieldValChange(item)"
                              v-if="item.basicAssemblyId == 12"></el-input>
                    <!--附件、图片、视频、音频-->
                    <resume-upload :ref="`resume${item.id}`" :upDateType="item.id" filtButtonName="上传文件"
                                   :filtButton="item.basicAssemblyId != 23" :threeFile="item.basicAssemblyId == 23"
                                   :fetchUrl="item.basicAssemblyId == 23 ? 'zyd-common/file/uploadThreeFile' : ''"
                                   :uploadNum="item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleNumberMax ? (item.metadataBasicDataRuleVo.ruleNumberMax)*1 : 500"
                                   :upFileSize="item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleMax ? (item.metadataBasicDataRuleVo.ruleMax)*1 : 2048"
                                   :allowFiles="astrictUploadFileFormat(item)"
                                   @upFileDate="getFileData($event, item)"
                                   v-if="(item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 17 || item.basicAssemblyId == 23) && method != 'view'"></resume-upload>
                    <!--文件列表-->
                    <el-table :data="form[item.basicCode]" size="small" border max-height="300"
                              v-if="(item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 17) && form[item.basicCode] && form[item.basicCode].length">
                        <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fileSizeFormat" label="大小"></el-table-column>
                        <el-table-column prop="createDate" label="上传时间"></el-table-column>
                        <el-table-column fixed="right" width="180" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" :disabled="false"
                                           @click="previewFile(scope.row, item.basicAssemblyId)">预览
                                </el-button>
                                <el-button type="text" size="small" :disabled="false" @click="downloadFile(scope.row)">
                                    下载
                                </el-button>
                                <el-button type="text" size="small" v-if="method != 'view'"
                                           @click="delFile(scope.row, scope.$index , item)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--三维文件列表-->
                    <el-table :data="form[item.basicCode]" size="small" border max-height="300" row-key="id"
                              :tree-props="{ children: 'fileList' }"
                              v-if="item.basicAssemblyId == 23 && form[item.basicCode] && form[item.basicCode].length">
                        <el-table-column prop="compressName" label="文件名称" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.compressName || scope.row.fileName}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="model" label="模型类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.fileList">
                                    {{$dictUtils.getDictLabel("three_type", scope.row.model, '')}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fileSizeFormat" label="大小"></el-table-column>
                        <el-table-column prop="createDate" label="上传时间"></el-table-column>
                        <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" :disabled="false" v-if="scope.row.fileList"
                                           @click="previewFile(scope.row, item.basicAssemblyId)">预览
                                </el-button>
                                <el-button type="text" size="small" :disabled="false" v-if="scope.row.fileList"
                                           @click="downloadFile(scope.row)">下载
                                </el-button>
                                <el-button type="text" size="small" v-if="method != 'view' && scope.row.fileList"
                                           @click="delFile(scope.row, scope.$index, item)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--关联数据-->
                    <div v-if="item.basicAssemblyId == 16">
                        <el-button type="primary" @click="associatedData(item)">关联数据</el-button>
                        <el-row class="m_t1" :gutter="4"
                                v-if="form[item.basicCode].length && item.basicDataIdList.length">
                            <el-col :span="3" class="associatedBasicData">
                                <el-link class="block fontSize12" :underline="false"
                                         :type="item.associatedBasicDataId == i ? 'primary':''"
                                         v-for="(v,i) in item.basicDataIdList" :key="i"
                                         @click="item.associatedBasicDataId = i">{{v.basicDataName}}
                                </el-link>
                            </el-col>
                            <el-col :span="21">
                                <el-table
                                        :data="item.basicDataIdList[item.associatedBasicDataId].metadataDataElasticSearchList"
                                        size="small" max-height="300"
                                        class="table" border>
                                    <el-table-column
                                            v-for="(v, i) in item.basicDataIdList[item.associatedBasicDataId].tableList"
                                            :key="i"
                                            :prop="v.basicCode"
                                            :label="v.basicRename" show-overflow-tooltip v-if="v.disabled == '0'"
                                            min-width="100">
                                        <template slot-scope="scope">
                                            <span>{{listDataFormat(v, scope.row.jsonData[v.basicCode])}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" label="操作" width="100">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" :disabled="false"
                                                       @click="viewAssociatedBasicData(scope.row, item)">查看
                                            </el-button>
                                            <el-button type="text" size="small"
                                                       @click="delAssociatedBasicData(item, scope.row, scope.$index)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="item.basicAssemblyId == 21 || item.basicAssemblyId == 22">{{form[item.basicCode]}}</div>
                    <div class="flex_b_c" v-if="item.basicForAddRang == '0' && method != 'view'">
                        <el-input v-model.trim="item.basicForAddRangVal" placeholder="请输入（限10字）" maxlength="10"
                                  clearable v-if="item.basicForAddRangFlag"></el-input>
                        <el-link class="fontSize12" icon="el-icon-plus" :underline="false" type="primary"
                                 @click="addBasicForAddRang(item)" v-else>添加新选项
                        </el-link>
                        <el-link class="m_l1" icon="el-icon-check" :underline="false" type="primary"
                                 @click="saveBasicForAddRang(item)" v-if="item.basicForAddRangFlag"></el-link>
                        <el-link class="m_l1" icon="el-icon-close" :underline="false" type="primary"
                                 @click="item.basicForAddRangFlag = false" v-if="item.basicForAddRangFlag"></el-link>
                    </div>
                </el-form-item>
                <!--标题-->
                <div v-if="item.basicAssemblyId == 18" class="m_l1 p_l1">
                    <el-descriptions class="title" :title="item.basicRename"></el-descriptions>
                    <AddEditFormItem :ref="`ref${item.basicCode}`" :refName="item.basicCode" :list="item.children"
                                     :allFieldList="allFieldList"
                                     :moduleType="18" :form="form" :allForm="form" :method="method"
                                     :metadataBasicDataRuleVoList="metadataBasicDataRuleVoList"
                                     :metadataBasicDataShowRuleVo="metadataBasicDataShowRuleVo"
                                     :metadataBasicDataRangeRuleVo="metadataBasicDataRangeRuleVo"></AddEditFormItem>
                </div>
            </div>
            <!--附件-->
            <el-form-item class="w100i" label="附件：" prop="metadataAttachments" v-if="refName == 'addEditFormItem'">
                <resume-upload ref="resourceAttachment" filtButtonName="上传文件"
                               :filtButton="true"
                               :uploadNum="500"
                               :upFileSize="2048"
                               :allowFiles="getSupportUploadFileFormat('', 'attachment_type')"
                               @upFileDate="getAttachmentFileData" v-if="method != 'view'"></resume-upload>
                <el-table :data="metadataAttachments" size="small" border v-if="metadataAttachments.length">
                    <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fileSizeFormat" label="大小"></el-table-column>
                    <el-table-column prop="createDate" label="上传时间"></el-table-column>
                    <el-table-column fixed="right" width="180" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" :disabled="false" @click="previewFile(scope.row, '13')">
                                预览
                            </el-button>
                            <el-button type="text" size="small" :disabled="false" @click="downloadFile(scope.row)">下载
                            </el-button>
                            <el-button type="text" size="small" v-if="method != 'view'"
                                       @click="delFile(scope.row, scope.$index)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
        </el-form>
        <!--关联数据弹窗-->
        <AssociatedData ref="associatedData" @refreshAssociatedData="getSelAssociatedData"></AssociatedData>
        <!--关联数据查看-->
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </div>
</template>

<script>
    import Editor from "@/components/editor/editor.vue";
    import resumeUpload from "@/components/Upload/resumeUpload.vue";
    import AddEditFormItem from './AddEditFormItem'
    import AssociatedData from './AssociatedData'

    export default {
        name: 'AddEditFormItem',
        props: {
            // 表单项
            list: {
                type: Array,
            },
            // 表单内容
            form: {
                type: Object,
            },
            refName: {
                type: String
            },
            allForm: {
                type: Object
            },
            method: {
                type: String
            },
            configId: {
                type: String
            },
            basicDataId: {
                type: String
            },
            // 数据规则
            metadataBasicDataRuleVoList: {
                type: Array
            },
            // 隐显规则
            metadataBasicDataShowRuleVo: {
                type: Array
            },
            // 值域规则
            metadataBasicDataRangeRuleVo: {
                type: Array
            },
            // 附件
            attachmentList: {
                type: Array,
                default: () => []
            },
            // 组件类型
            moduleType: {
                type: Number,
                default: () => 0
            },
            // 所有字段集合
            allFieldList: {
                type: Array,
                default: () => []
            },
        },
        components: {Editor, resumeUpload, AddEditFormItem, AssociatedData},
        data() {
            return {
                formData: {},
                metadataAttachments: [],
                routeInfo: {}, // 当前路由信息
            }
        },
        watch: {
            'list'(val) {
                this.fileEcho(val)
                this.fieldValChange()
                this.hidingRule()
            },
            'attachmentList'() {
                if (this.refName == 'addEditFormItem') {
                    this.metadataAttachments = this.attachmentList
                    setTimeout(() => {
                        if (this.$refs[`resourceAttachment`]) {
                            this.$refs[`resourceAttachment`].setOldFile(this.metadataAttachments)
                        }
                    }, 500)
                }
            },
        },
        mounted() {
            let dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
            this.routeInfo = dynamicMenuRoutes.filter(item => item.fullPath === this.$route.fullPath)[0]
            this.formData = this.allForm
            if (this.moduleType != 0) {
                this.fieldValChange()
                this.hidingRule()
            }
        },
        methods: {
            // 上传文件回显
            fileEcho(list) {
                let fileList = list.filter(item => item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 17 || item.basicAssemblyId == 23)
                setTimeout(() => {
                    fileList.map(item => {
                        if (this.$refs[`resume${item.id}`] && this.$refs[`resume${item.id}`].length && item.basicCode) {
                            this.$refs[`resume${item.id}`][0].setOldFile([])
                            this.$refs[`resume${item.id}`][0].setOldFile(this.form[item.basicCode])
                        }
                    })
                }, 500)

            },
            // 获取富文本数据
            contentGetEditor(data, val) {
                if (data === '<p><br></p>' || !data) {
                    data = '';
                }
                this.form[val.basicCode] = data;
                if (data) {
                    this.$refs[this.refName].clearValidate([val.basicCode]);
                }
            },
            // 获取上传的文件
            getFileData(data, val) {
                this.form[val.basicCode] = []
                data.map(item => {
                    if (item.upDate) {
                        this.$set(item.upDate, 'id', item.id)
                        this.$set(item.upDate, 'model', item.model)
                        this.form[val.basicCode].push(item.upDate)
                    } else {
                        this.form[val.basicCode].push(item)
                    }
                })
                if (data.length) {
                    this.$refs[this.refName].clearValidate([val.basicCode]);
                }
                this.accessoriesParameters()
            },
            // 获取上传的附件
            getAttachmentFileData(data) {
                this.metadataAttachments = []
                data.map(item => {
                    if (item.upDate) {
                        this.$set(item.upDate, 'id', item.id)
                        this.metadataAttachments.push(item.upDate)
                    } else {
                        this.metadataAttachments.push(item)
                    }
                })
            },
            // 关联数据
            associatedData(item) {
                if (!item.metadataBasicDataRuleVo || !item.metadataBasicDataRuleVo.associationBasicDataId) {
                    this.$message.warning('请先在 元数据规则管理-数据规则 设置数据来源')
                    return
                }
                this.$nextTick(() => {
                    this.$refs.associatedData.init(item, this.form[item.basicCode])
                })
            },
            // 获取关联数据
            getSelAssociatedData(data) {
                this.form[data.itemInfo.basicCode] = data.selId
                this.$set(data.itemInfo, 'associatedBasicDataId', 0)
                this.$set(data.itemInfo, 'basicDataIdList', data.basicDataIdList)
            },
            // 查看关联元数据
            viewAssociatedBasicData(row, item) {
                if (!item.metadataBasicDataRuleVo.associationBasicDataId) {
                    return
                }
                this.$refs.resourceAddEditForm.init('view', row.id, item.metadataBasicDataRuleVo.associationBasicDataId, row.basicDataId)
            },
            // 删除关联元数据
            delAssociatedBasicData(item, row, index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let list = item.basicDataIdList[item.associatedBasicDataId].metadataDataElasticSearchList
                    list.splice(index, 1);
                    this.form[item.basicCode] = this.form[item.basicCode].filter(id => id != row.id)
                    if (!list.length) {
                        this.$set(item, 'associatedBasicDataId', 0)
                        item.basicDataIdList = item.basicDataIdList.filter(v => v.metadataDataElasticSearchList.length > 0)
                    }
                })
            },
            // 预览
            previewFile(row, basicAssemblyId) {
                let format = this.getSupportPreviewFileFormat(basicAssemblyId)
                if (format.indexOf(row.fileFormat) == -1) {
                    this.$message.error('暂不支持预览' + row.fileFormat + '格式')
                    return
                }
                row.basicAssemblyId = basicAssemblyId
                sessionStorage.setItem('previewFileInfo', JSON.stringify(row))
                window.open(this.$router.resolve({path: "/preview",}).href, '_blank');
            },
            // 下载
            downloadFile(row) {
                this.$confirm(`确认下载所选资源?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let resourceName = row.fileName || row.compressName || ''
                    this.fileBlobDownload(this.api.allCommon.fileDownload, {
                        resourceName,
                        source: row.netUrl || row.compressUrl || '',
                    }, resourceName, '', 'get')
                })
            },
            // 删除附件
            delFile(row, index, item) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (item) {
                        this.form[item.basicCode] = this.form[item.basicCode].filter(v => v.id != row.id)
                        this.$refs[`resume${item.id}`][0].deleteFile(row.fileID ? row.fileID : row.id)
                    } else {
                        this.metadataAttachments.splice(index, 1);
                        this.$refs[`resourceAttachment`].deleteFile(row.fileID ? row.fileID : row.id)
                    }
                    this.accessoriesParameters()
                })
            },
            // 可查看、可编辑、可新增
            getBasicForAdd(item) {
                // 是否配置隐显规则
                if (item.basicAssemblyId == '18') {
                    return true
                } else if (item.basicForEdit == '0') {
                    return true
                } else if (this.method == 'view' && item.basicForShow == '0') {
                    return true
                } else if (this.method == 'add' && item.basicForAdd == '0') {
                    return true
                }
            },
            // 限制上传文件格式
            astrictUploadFileFormat(item) {
                let format = []
                if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleFormatRestrictions) {
                    format = item.metadataBasicDataRuleVo.ruleFormatRestrictions.split(";")
                } else {
                    format = this.getSupportUploadFileFormat(item.basicAssemblyId)
                }
                return format
            },
            // 新增值域
            addBasicForAddRang(item) {
                this.$set(item, 'basicForAddRangVal', '')
                this.$set(item, 'basicForAddRangFlag', true)
            },
            // 保存值域
            saveBasicForAddRang(item) {
                if (!item.basicForAddRangVal) {
                    this.$message.error('请输入值域')
                    return
                }
                let repetition = item.basicRangeList.filter(v => {
                    return v.basicRange == item.basicForAddRangVal
                })
                if (repetition.length) {
                    this.$message.warning('值域选项不能重复')
                    return
                }
                this.loading = true
                let range = {
                    basicRange: item.basicForAddRangVal,
                    sort: item.basicRangeList.length + 1
                }
                item.basicRangeList.push(range)
                this.$axios(this.api.metadata.metadatarangeSave, {
                    basicId: item.associationBasicId,
                    basicForAddRang: '0',
                    basicRangeList: item.basicRangeList
                }, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('操作成功')
                        this.$set(item, 'basicForAddRangVal', '')
                        this.$set(item, 'basicForAddRangFlag', false)
                    } else {
                        this.$message.error(data.msg)
                        item.basicRangeList = item.basicRangeList.filter(v => v.basicRange != range.basicRange)
                    }
                    this.loading = false
                })
            },
            // 字段值发生改变 (数据规则-字段叠加) type：1初始化
            fieldValChange(item) {
                if (item && item.basicAssemblyId == 12) {
                    this.form[item.basicCode] = this.form[item.basicCode].replace(/[^\d-.]/g, '')
                }
                this.metadataBasicDataRuleVoList.map(m => {
                    if (m.ruleMode == '1' && m.ruleDetailList.length) {
                        let val = ''
                        m.ruleDetailList.map((v, i) => {
                            if (v.refixed == '0') {
                                val = val + v.fieldOverlayFixed + m.ruleSplit
                            }
                            if (v.renumber == '0') {
                                if (parseInt(m.latestSeq) > parseInt(m.ruleStartNumber)) {
                                    val = val + m.latestSeq + m.ruleSplit
                                } else {
                                    val = val + m.ruleStartNumber + m.ruleSplit
                                }
                            }
                            if (v.redate == '0') {
                                val = val + this.formatDate('', 0) + m.ruleSplit
                            }
                            if (v.basicCode && this.form[v.basicCode]) {
                                if (item && this.listDataFormat(item, this.form[item.basicCode])) {
                                    val = val + this.listDataFormat(item, this.form[item.basicCode]) + m.ruleSplit
                                } else {
                                    val = val + this.form[v.basicCode] + m.ruleSplit
                                }
                            }
                        })
                        this.form[m.basicCode] = val.substr(0, val.length - 1)
                    }
                })
            },
            // 数据规则-附件参数
            accessoriesParameters() {
                this.metadataBasicDataRuleVoList.map(m => {
                    if (m.ruleMode == '2') {
                        let list = this.form[m.ruleAssociationBasicCode], val = {}
                        if (list && list.length) {
                            val = this.form[m.ruleAssociationBasicCode][0]
                        }
                        this.form[m.basicCode] = val[m.ruleAssociationValue] || ''
                    }
                })
            },
            // 隐显规则、值域规则
            hidingRule(item) {
                if (this.metadataBasicDataShowRuleVo) {
                    let basicCode = '', conformNum = 0
                    this.metadataBasicDataShowRuleVo.map(m => {
                        basicCode = m.basicCode
                        let andNum = 0, rangeLen = 0
                        m.metadataBasicDataShowRuleDetailList.map(v => {
                            v.basicRanges.map(r => {
                                if (!this.form[v.basicCode]) {
                                    return
                                }
                                if(Array.isArray(this.form[v.basicCode])) {
                                    rangeLen = this.form[v.basicCode].filter(val => val == r.basicRange).length
                                }
                                if(!Array.isArray(this.form[v.basicCode]) && this.form[v.basicCode] == r.basicRange) {
                                    rangeLen++
                                }
                                if (m.ruleWhere == '0') {
                                    if ((v.basicCondition == '包含' && rangeLen > 0) || v.basicCondition == '不包含' && rangeLen == 0) {
                                        andNum++
                                    }
                                    if (andNum == m.metadataBasicDataShowRuleDetailList.length) {
                                        conformNum++
                                    }
                                } else {
                                    if ((v.basicCondition == '包含' && rangeLen > 0) || v.basicCondition == '不包含' && rangeLen == 0) {
                                        conformNum++
                                    }
                                }
                            })
                        })
                    })
                    this.$nextTick(() => {
                        let field = this.recursion(this.allFieldList, basicCode)
                        if (conformNum > 0) {
                            this.$set(field, 'showRuleFlag', true)
                        } else {
                            this.$set(field, 'showRuleFlag', false)
                        }
                    })
                }
                if (this.metadataBasicDataRangeRuleVo) {
                    let basicCode = '', conformNum = 0, basicRangeList = [], basicRangeListAll = [],
                        ruleDefaultValue = []
                    this.metadataBasicDataRangeRuleVo.map(m => {
                        basicCode = m.basicCode
                        basicRangeList = m.metadataBasicDataRangeRuleValueList || []
                        basicRangeListAll = m.rangesValue || []
                        m.ruleDefaultValue.map(d => {
                            ruleDefaultValue.push(d.basicRange)
                        })
                        let andNum = 0, rangeLen = 0
                        m.metadataBasicDataRangeRuleDetailList.map(v => {
                            v.basicRanges.map(r => {
                                if (!this.form[v.basicCode]) {
                                    return
                                }
                                if(Array.isArray(this.form[v.basicCode])) {
                                    rangeLen = this.form[v.basicCode].filter(val => val == r.basicRange).length
                                }
                                if(!Array.isArray(this.form[v.basicCode]) && this.form[v.basicCode] == r.basicRange) {
                                    rangeLen++
                                }
                                if (m.whereState == '0') {
                                    if ((v.basicCondition == '包含' && rangeLen > 0) || v.basicCondition == '不包含' && rangeLen == 0) {
                                        andNum++
                                    }
                                    if (andNum == m.metadataBasicDataRangeRuleDetailList.length) {
                                        conformNum++
                                    }
                                } else {
                                    if ((v.basicCondition == '包含' && rangeLen > 0) || v.basicCondition == '不包含' && rangeLen == 0) {
                                        conformNum++
                                    }
                                }
                            })
                        })
                        if (!m.metadataBasicDataRangeRuleDetailList.length) {
                            conformNum++
                        }
                    })
                    this.$nextTick(() => {
                        let field = this.recursion(this.allFieldList, basicCode)
                        if (conformNum > 0) {
                            this.$set(field, 'basicRangeList', basicRangeList)
                            this.$nextTick(() => {
                                if(item && item.basicCode != basicCode) {
                                    if (ruleDefaultValue.length) {
                                        if (field.basicAssemblyId == 6 || field.basicAssemblyId == 7) {
                                            this.form[basicCode] = ruleDefaultValue
                                        } else {
                                            this.form[basicCode] = ruleDefaultValue[0]
                                        }
                                    } else {
                                        this.form[basicCode] = null
                                    }
                                }
                            })
                        } else {
                            this.$set(field, 'basicRangeList', basicRangeListAll)
                        }
                    })
                }
            },
            // 递归获取字段
            recursion(list, code) {
                let field = {}
                list.map(item => {
                    if (item.basicCode == code) {
                        field = item
                    }
                    if (item.children.length && item.basicAssemblyId == '18') {
                        this.recursion(item.children, code)
                    }
                })
                return field
            },
            // 提交  type 1当前表单，19子表单，20子模板
            doSubmit(type, data, id, metadataFonctionsModelDetailId) {
                let flag = false
                this.$refs[this.refName].validate((valid) => {
                    if (valid) {
                        if (type == '19') {
                            flag = true
                            let list = this.formData[data.subformInfo.basicCode]
                            if (this.method == 'add') {
                                data.form.id = Date.now() + ''
                                list.push(data.form)
                            } else {
                                list = list.map(v => {
                                    return v.id === data.form.id ? data.form : v;
                                });
                            }
                            this.formData[data.subformInfo.basicCode] = list
                        } else if (type == '20') {
                            flag = true
                        } else if (type == '1') {
                            this.saveData(data, id, metadataFonctionsModelDetailId)
                        }
                    }
                })
                return flag
            },
            // 提交数据
            saveData(basicDataId, id, metadataFonctionsModelDetailId) {
                for (let key in this.formData) {
                    if (!key) {
                        delete this.formData[key]
                    }
                }
                let p = {
                    basicDataId,
                    id,
                    metadataFonctionsModelDetailId,
                    configId: this.configId,
                    menuId: this.routeInfo.meta.menuId,
                    jsonData: this.formData,
                    metadataAttachments: this.metadataAttachments
                }
                this.loading = true
                this.$axios(this.api.metadata.saveMetadataData, p, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('操作成功')
                        this.$emit("refreshData")
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.loading = false
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .formBox {
        padding: 10px;
    }

    .formBox::v-deep .el-form-item--small .el-form-item__content {
        width: calc(100% - 150px) !important;
    }

    .associatedBasicData {
        max-height: 300px;
        overflow-y: auto;
    }
</style>
